'use strict';

angular.module('controllers')
	.directive('resizer', ['$document', function($document) {
		return function($scope, $element, $attrs) {

			angular.element($element[0].querySelector('#left-expand')).bind('click', function (event) {
				var widthRightBar = $('#rightbar').width();
				angular.element(document.querySelector('#sidebar')).toggleClass('max-size ');
				if (angular.element(document.querySelector('#sidebar')).hasClass('max-size')) {
					angular.element(document.querySelector('#sidebar-resizer')).css('left', '0');
					$($attrs.resizerLeft).css({width: 0 + 'px'});
					$($attrs.resizerRight).css({width: (parseInt(window.innerWidth) - widthRightBar -30) + 'px'});
				} else {
					angular.element(document.querySelector('#sidebar-resizer')).css('left', '250px');
					$($attrs.resizerLeft).css({width: 250 + 'px'});
					$($attrs.resizerRight).css({width: (parseInt(window.innerWidth) - 250 - widthRightBar -30) + 'px'});
				}
				var widthContentBar = $('#content').width();
				if(widthContentBar <= '500') {
					$($attrs.resizerRight + ' .wrap-card').addClass('m500');
				}else{
					$($attrs.resizerRight + ' .wrap-card').removeClass('m500');
				}
			});

			angular.element($element[0].querySelector('#right-expand')).bind('click', function (event) {
				var widthSideBar = $('#sidebar').width();
				var widthLeftBar = parseInt(window.innerWidth) - widthSideBar - 30;
				angular.element(document.querySelector('#rightbar')).toggleClass('max-size ');
				if (angular.element(document.querySelector('#rightbar')).hasClass('max-size')) {
					angular.element(document.querySelector('#rightbar-resizer')).css('left', 'calc(100vw - 15px)');
					$($attrs.resizerLeft).css({width: (widthLeftBar) + 'px'});
					$($attrs.resizerRight).css({width: (0) + 'px'});
				} else {
					angular.element(document.querySelector('#rightbar-resizer')).css('left', 'calc(100vw - 215px)');
					$($attrs.resizerLeft).css({width: (widthLeftBar -200) + 'px'});
					$($attrs.resizerRight).css({width: (200) + 'px'});
				}
				if(widthLeftBar <= '500') {
					$($attrs.resizerLeft + ' .wrap-card').addClass('m500');
				}else{
					$($attrs.resizerLeft + ' .wrap-card').removeClass('m500');
				}
			});

			$element.on('mousedown', function(event) {
				event.preventDefault();

				$document.on('mousemove', mousemove);
				$document.on('mouseup', mouseup);
			});

			function mousemove(event) {

				if ($attrs.resizer == 'vertical') {

					if ($attrs.resizerOrientation == 'left') {
						var x = event.pageX;

						if ($attrs.resizerMax && x > $attrs.resizerMax) {
							x = parseInt($attrs.resizerMax);
						}

						$element.css({left: x + 'px'});

						$($attrs.resizerLeft).css({width: x + 'px'});
						$($attrs.resizerRight).css({left: (x + parseInt($attrs.resizerWidth)) + 'px'});

						var widthRightBar = $('#rightbar').width();
						$($attrs.resizerRight).css({width: (parseInt(window.innerWidth) - x - widthRightBar - 25) + 'px'});

						var widthContentBar = $($attrs.resizerRight).width();
						if(widthContentBar <= '500') {
							$($attrs.resizerRight + ' .wrap-card').addClass('m500');
						}else{
							$($attrs.resizerRight + ' .wrap-card').removeClass('m500');
						}
					}else{
						var x = event.pageX;
						if ($attrs.resizerMax && x > $attrs.resizerMax) {
							x = parseInt($attrs.resizerMax);
						}
						if(x > 400) {
							$element.css({left: (x ) + 'px'});

							var widthSideBar = $('#sidebar').width();
							var widthLeftBar = x - widthSideBar - 15;
							$($attrs.resizerLeft).css({width: (widthLeftBar) + 'px'});

							if(widthLeftBar <= '500') {
								$($attrs.resizerLeft + ' .wrap-card').addClass('m500');
							}else{
								$($attrs.resizerLeft + ' .wrap-card').removeClass('m500');
							}

							$($attrs.resizerRight).css({left: (0) + 'px'});
							if($attrs.resizerMax == 'max'){
								var maxWidthInterval = window.innerWidth;
							}else{
								var maxWidthInterval = $attrs.resizerMax;
							}
							$($attrs.resizerRight).css({width: (parseInt(maxWidthInterval) - x -10) + 'px'});

							angular.element(window).bind('resize', function(){
								$($attrs.resizerRight).css({width: (parseInt(window.innerWidth) - x -10) + 'px'});
							});
						}
					}
				} else {
					// Handle horizontal resizer
					var y = window.innerHeight - event.pageY;
					$element.css({bottom: y + 'px'});
					$($attrs.resizerTop).css({bottom: (y + parseInt($attrs.resizerHeight)) + 'px'});
					$($attrs.resizerBottom).css({height: y + 'px'});
				}
			}

			function mouseup() {
				$document.unbind('mousemove', mousemove);
				$document.unbind('mouseup', mouseup);
			}
		};
	}]);
